module.exports = __webpack_public_path__ + "static/img/videoPic4.d2ba44a2.png";